<div class="top">
  <div class="heading">
    <span class="fw-bold">NEW IGR ASSESSMENT</span>
  </div>
  <i class="material-icons text-danger" role="button" (click)="closeModal()">
    close
  </i>
</div>

<div class="form-wrapper">
  <form [formGroup]="form" (ngSubmit)="proceed()">
    <div class="d-flex flex-column flex-md-row gap-2 w-100">
      <div class="field">
        <label for="name">ASIN</label>
        <input id="name" type="text" formControlName="asin" maxlength="40" class="form-control" placeholder="Enter ASIN"
          appOnlyNumber />
      </div>

      <div class="field">
        <label for="name">SELECT YEAR</label>
        <select formControlName="assessmentYear" class="form-control form-select">
          <option [value]="year" *ngFor="let year of years">
              {{year}}
          </option>
        </select>
      </div>

      <div class="d-flex align-items-end">
        <div class="modal-actions-wrapper">
          <button type="submit" class="custom-btn-primary w-100" [disabled]="
                !form?.dirty || form?.invalid
              ">
            <ng-container *ngIf="!isSubmitting; else loadingTemplate">
              <span>Verify</span>
            </ng-container>
            <ng-template #loadingTemplate>
              <span>Verifying...</span>
            </ng-template>
          </button>
        </div>
      </div>
    </div>


  </form>
</div>